<template>
  <v-app>
    <transition mode="out-in">
      <router-view></router-view>
    </transition>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue